import { IUpcomingEvents } from '../../../models/interfaces/iUpcomingEvents';
import { UpcomingEvents } from '../../../models/classes/upcomingEvents';

export default class State {
  public orgKey: string = '';
  public eventType: string = 'All';
  public eventKey: string = '';
  public isAts: number = 0;
  public upcomingEvents: IUpcomingEvents = new UpcomingEvents();
}



// WEBPACK FOOTER //
// ./static-content/private/javascripts/store/modules/events/state.ts